// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
      	enableAjaxCart: true,
		//paginationType: boostPFSConfig.custom.enable_infinite_scrolling? "infinite": "default",
	},
  	selector: {
		otpTopCartLink: 'header a[href="/cart"]',
		otpTopCartCount: '.cart-item-count-header--quantity',
	}
};

// Declare Templates
var boostPFSTemplate = {
	saleLabelHtml: '<div class="sale-badge">' + boostPFSConfig.label.on_sale + "</div>",
	soldOutLabelHtml: '<div class="sold-out-badge">' + boostPFSConfig.label.sold_out + "</div>",
	vendorHtml:'<div class="product-grid--vendor-text">{{itemVendorLabel}}</div>',

	// Grid Template
	productGridItemHtml: 	'<div class="grid__item ' + boostPFSConfig.custom.grid_item_width + '">' +
								'<div class="grid-view-item">' +
									'<div class="grid-view-item-image">' +
										"{{itemCriticRating}}" +
										"{{itemImages}}" +
										"{{itemQuickview}}" +
									'</div>' +
									'<div class="grid-view-item--desc-wrapper grid-uniform">' +
										'<div class="large--one-whole">' +
											'{{itemVendor}}' +
											'<p class="product-grid--title">' +
												'<a href="{{itemUrl}}">{{itemTitle}}</a>' +
											'</p>' +
											'<p class="product-grid--price">' +
												'{{itemPrice}}' +
												'{{itemReviews}}' +
											'</p>' +
										'</div>' +
									'</div>' +
									'{{itemBadges}}' +
								'</div>' +
							'</div>',
  	productListItemHtml: 	'<div class="boost-pfs-filter-product-item boost-pfs-filter-product-item-list">' +
								'<div class="boost-pfs-filter-product-item-list-col-1">' +
                                 ' <div class="boost-pfs-filter-product-item-image">' +
  									'{{itemImages}}' +
                                  '</div>' +
                                '</div>' +
                                '<div class="boost-pfs-filter-product-bottom">' +
                                 	'<p class="product-grid--title">' +
                                  		'<a href="{{itemUrl}}">{{itemTitle}}</a>' +
                                    '</p>' +
                                    '{{itemVendor}}' +
                                    '<p class="product-grid--price text-left">' +
                                      '{{itemPrice}}' +
                                    '</p>' +
  									'{{itemReviews}}' +
                                    '{{itemBadges}}' +
                                '</div>' +
							'</div>',

	// Pagination Template
	previousActiveHtml: '<li class="pagination-arrow"><a href="{{itemUrl}}"><i class="fa fa-chevron-left"></i></a></li>',
	previousDisabledHtml: '<li class="prev disabled"><a href="#" onclick="return false;">&laquo;</a></li>',
	nextActiveHtml: '<li class="pagination-arrow"><a href="{{itemUrl}}"><i class="fa fa-chevron-right"></i></a></li>',
	nextDisableHtml: '<li class="next disabled"><a href="#" onclick="return false;">&raquo;</a></li>',
	pageItemHtml: '<li class="pagination-number"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></li>',
	pageItemSelectedHtml: '<li class="active pagination-number"><a href="" title="">{{itemTitle}}</a></li>',
	pageItemRemainHtml: '<li class="ellipsis">{{itemTitle}}</li>',
	paginateHtml: "<ul>{{previous}}{{pageItems}}{{next}}</ul>",

	// Sorting Template
	sortingHtml: '<label for="bc-sf-filter-top-sorting-select">' +boostPFSConfig.label.sorting +'</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>',
};

(function () {
	// Add this
	BoostPFS.inject(this); // Add this

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {

		if (!data) data = this.data; // Add this line
		if (!index) index = this.index; // Add this line
		if (!totalProduct) totalProduct = this.totalProduct;

		var soldOut = !data.available;
		var onSale = data.compare_at_price_min > data.price_min;
		var priceVaries = data.price_min != data.price_max;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Aether critic rating badge. Boost receives product tags on every AJAX render.
		var criticRatingHtml = buildCriticRating(data);
		itemHtml = itemHtml.replace(/{{itemCriticRating}}/g, criticRatingHtml);

		// Add class
		// Add Badges
		var itemBadgesHtml = "";
		if (boostPFSConfig.custom.enable_sale_badge && onSale && data.available) {
			itemBadgesHtml += boostPFSTemplate.saleLabelHtml;
		}
		if (boostPFSConfig.custom.enable_sold_out_badge && !data.available) {
			itemBadgesHtml += boostPFSTemplate.soldOutLabelHtml;
		}
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.show_vendor ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor): "";
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data, soldOut, onSale, priceVaries));

		// Add Reviews
		var itemReviewsHtml = boostPFSConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>': "";
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Quick view
		itemHtml = itemHtml.replace(/{{itemQuickview}}/g, buildHover(data));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g,Utils.buildProductItemUrl(data));

		return itemHtml;
	};
	
  	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data; // Add this line
		if (!index) index = this.index; // Add this line
		if (!totalProduct) totalProduct = this.totalProduct;

		var soldOut = !data.available;
		var onSale = data.compare_at_price_min > data.price_min;
		var priceVaries = data.price_min != data.price_max;
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add class
		// Add Badges
		var itemBadgesHtml = "";
		if (boostPFSConfig.custom.enable_sale_badge && onSale && data.available) {
			itemBadgesHtml += boostPFSTemplate.saleLabelHtml;
		}
		if (boostPFSConfig.custom.enable_sold_out_badge && !data.available) {
			itemBadgesHtml += boostPFSTemplate.soldOutLabelHtml;
		}
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.show_vendor ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor): "";
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data, soldOut, onSale, priceVaries));

		// Add Reviews
		var itemReviewsHtml = boostPFSConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>': "";
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Quick view
		itemHtml = itemHtml.replace(/{{itemQuickview}}/g, buildHover(data));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g,Utils.buildProductItemUrl(data));

		return itemHtml;
	};
	/************************** END BUILD PRODUCT LIST **************************/
	
	function buildCriticRating(data) {
		var tags = Array.isArray(data.tags) ? data.tags : [];
		var primaryScore = "";
		var primaryAuthority = "";
		var secondaryScore = "";
		var secondaryAuthority = "";

		function normaliseDisplayScore(raw) {
			raw = String(raw || "").trim();

			/* Range tags use hyphens, but the customer-facing badge uses an en dash. */
			var rangeMatch = raw.match(/^(\d{2})-(\d{2})$/);
			if (rangeMatch) {
				return rangeMatch[1] + "–" + rangeMatch[2];
			}

			return raw;
		}

		function scoreForComparison(raw) {
			raw = String(raw || "").trim();

			/* For a published range, compare using its upper bound.
			   This only decides which critic badge to show when two ratings exist;
			   the full published range is still displayed unchanged. */
			var rangeMatch = raw.match(/^(\d{2})-(\d{2})$/);
			if (rangeMatch) {
				return parseFloat(rangeMatch[2]);
			}

			return parseFloat(raw);
		}

		for (var i = 0; i < tags.length; i++) {
			var tag = String(tags[i]);

			/* Range tags must be checked before the normal critic-score prefix. */
			if (tag.indexOf("critic-score-range-2-") === 0) {
				secondaryScore = tag.replace("critic-score-range-2-", "");
			} else if (tag.indexOf("critic-score-2-") === 0) {
				secondaryScore = tag.replace("critic-score-2-", "");
			} else if (tag.indexOf("critic-score-range-") === 0) {
				primaryScore = tag.replace("critic-score-range-", "");
			} else if (tag.indexOf("critic-score-") === 0) {
				primaryScore = tag.replace("critic-score-", "");
			}

			if (tag.indexOf("critic-authority-2-") === 0) {
				secondaryAuthority = tag.replace("critic-authority-2-", "").replace(/-/g, " ");
			} else if (tag.indexOf("critic-authority-") === 0) {
				primaryAuthority = tag.replace("critic-authority-", "").replace(/-/g, " ");
			}
		}

		var score1 = scoreForComparison(primaryScore);
		var score2 = scoreForComparison(secondaryScore);
		var score = "";
		var authority = "";

		if (!isNaN(score1) && !isNaN(score2)) {
			if (score2 > score1) {
				score = secondaryScore;
				authority = secondaryAuthority;
			} else {
				score = primaryScore;
				authority = primaryAuthority;
			}
		} else if (!isNaN(score1)) {
			score = primaryScore;
			authority = primaryAuthority;
		} else if (!isNaN(score2)) {
			score = secondaryScore;
			authority = secondaryAuthority;
		} else {
			return "";
		}

		var displayScore = normaliseDisplayScore(score);
		var isRange = displayScore.indexOf("–") !== -1;

		var authorityLabel = authority.replace(/\b\w/g, function(letter) {
			return letter.toUpperCase();
		});

		var html = '<div class="aether-boost-rating">';
		html += '<span class="aether-boost-score' + (isRange ? ' aether-boost-score--range' : '') + '">' + displayScore + '</span>';

		if (authorityLabel) {
			html += '<span class="aether-boost-authority">' + authorityLabel + '</span>';
		}

		html += '</div>';
		return html;
	}

	function buildImages(data) {
		var images = data.images_info;
		var html = "";
		if (boostPFSConfig.custom.hover_effect) {
			if (images.length > 1) {
				html += '<div class="reveal">';
				html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
				html += '<img src="' + Utils.optimizeImage(images[0]["src"], "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
				html += '<div class="hidden">';
				html +='<img src="' + Utils.optimizeImage(images[1]["src"], "760x") + '" alt="{{itemTitle}}" class="img-responsive" />';
				html += "</div>";
				html += "</a>";
				html += "</div>";
			} else {
				html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
				html += '<img src="' + Utils.getFeaturedImage(images, "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
				html += "</a>";
			}
		} else {
			html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
			html += '<img src="' + Utils.getFeaturedImage(images, "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
			html += "</a>";
		}
		return html;
	}

	function buildHover(data) {
		var html = "";
		if (boostPFSConfig.custom.quick_shop_enable) {
		html += '<div class="shop-now-wrapper">';
		html += '<a class="shop-now-button" href="{{itemUrl}}">' + boostPFSConfig.label.quick_shop + '</a>';
		html += '</div>';
		}
		return html;
	}

	function buildPrice(data, soldOut, onSale, priceVaries) {
		var html = '';
		if (onSale) {
			if (priceVaries) {
				html += boostPFSConfig.label.sale_from_price.replace( /{{ price }}/g, '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>');
			} else {
				html += '<span class="product-grid--compare-price">' + Utils.formatMoney(data.compare_at_price_min) + "</span>";
				html += ' <span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
			}
		} else {
			if (priceVaries) {
				html += ' <span class="product-grid--from-wrapper">' + boostPFSConfig.label.from_price + '</span> <span class="money">' + Utils.formatMoney(data.price_min) + "</span>";
			} else {
				html += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
			}
		}
		if (soldOut) {
			html += '<br><strong>' + boostPFSConfig.label.sold_out + '</strong>';
		}
		return html;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift("...");
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push("...");
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = "";
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == "...") {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
		
		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = "";
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + "</option>";
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}
		return '';
	};
  
  	/************************** BUILD TOOLBAR **************************/
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span> View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};
	
	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
      
		//Call theme function
		if (window.wetheme && typeof wetheme.load_all == "function") {
			wetheme.load_all({});
		}
		buildTheme();
		injectAetherCriticBadges(data);
		setTimeout(function(){ injectAetherCriticBadges(data); }, 100);
      	buildImageSize();
        jQ(window).on('resize', function(){
          buildImageSize();
        });
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function (data, eventType) {
      	if (!data) data = this.data;
      
    	var totalProduct = data.total_product + '<span> Products</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> Product</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
    };


	function injectAetherCriticBadges(data) {
		var products = [];

		if (data && Array.isArray(data.products)) {
			products = data.products;
		} else if (
			window.boostPFS &&
			boostPFS.filter &&
			boostPFS.filter.data &&
			Array.isArray(boostPFS.filter.data.products)
		) {
			products = boostPFS.filter.data.products;
		}

		if (!products.length) return;

		var productsByHandle = {};
		products.forEach(function(product) {
			if (product && product.handle) {
				productsByHandle[String(product.handle)] = product;
			}
		});

		document.querySelectorAll('.grid-view-item').forEach(function(card) {
			if (card.querySelector('.aether-boost-rating')) return;

			var link = card.querySelector('a[href*="/products/"]');
			var imageWrap = card.querySelector('.grid-view-item-image');
			if (!link || !imageWrap) return;

			var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
			if (!match) return;

			var handle = decodeURIComponent(match[1]);
			var product = productsByHandle[handle];
			if (!product) return;

			var tags = Array.isArray(product.tags) ? product.tags : [];
			var isAetherSelection = tags.some(function(tag) {
				return String(tag).toLowerCase() === 'aether-selection';
			});
			if (!isAetherSelection) return;

			var badgeHtml = buildCriticRating(product);
			if (!badgeHtml) return;

			imageWrap.insertAdjacentHTML('afterbegin', badgeHtml);
		});
	}

	function buildTheme() {
		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}
		Shopify.PaymentButton.init();

		if (boostPFSConfig.custom.show_multiple_currencies) {
			convertCurrencies();
		}
	}
  
    function buildImageSize(){
      jQ('.grid-view-item-image').each(function(){
      	var imageWidth = jQ(this).find('img').width();
        var imageHeight = imageWidth + (imageWidth / 2);
        jQ(this).find('img').height(imageHeight);
      });
    }
  

	// Aether: watch the live product grid because Boost can replace cards after AJAX pagination/filtering.
	function startAetherBadgeObserver() {
		var target = document.querySelector('.collection-main-body-inner') || document.body;
		if (!target || target.__aetherBadgeObserverStarted) return;

		target.__aetherBadgeObserverStarted = true;

		var observer = new MutationObserver(function() {
			window.requestAnimationFrame(function() {
				injectAetherCriticBadges();
			});
		});

		observer.observe(target, {
			childList: true,
			subtree: true
		});

		// Initial pass after Boost has had time to render.
		setTimeout(function() {
			injectAetherCriticBadges();
		}, 250);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', startAetherBadgeObserver);
	} else {
		startAetherBadgeObserver();
	}

})();


// Aether critic badge styles — injected once and not removed by Boost pagination.
(function () {
	if (document.getElementById("aether-boost-rating-styles")) return;

	var style = document.createElement("style");
	style.id = "aether-boost-rating-styles";
	style.textContent = `
		.grid-view-item-image {
			position: relative;
		}

		.aether-boost-rating {
			position: absolute;
			top: 12px;
			left: 12px;
			z-index: 50;
			display: flex;
			flex-direction: column;
			align-items: center;
			pointer-events: none;
		}

		.aether-boost-score {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 50px;
			height: 50px;
			box-sizing: border-box;
			border-radius: 50%;
			background: #c9a765;
			color: #fff;
			font-size: 21px;
			font-weight: 700;
			line-height: 1;
		}

		.aether-boost-score--range {
			font-size: 13px;
			letter-spacing: -0.03em;
			white-space: nowrap;
		}

		.aether-boost-score::after {
			content: "";
			position: absolute;
			inset: 3px;
			border: 1px solid #fff;
			border-radius: 50%;
			pointer-events: none;
		}

		.aether-boost-authority {
			margin-top: 5px;
			color: #333;
			font-size: 7px;
			font-weight: 500;
			line-height: 1.15;
			letter-spacing: .07em;
			text-transform: uppercase;
			text-align: center;
			white-space: nowrap;
		}

		@media screen and (max-width: 767px) {
			.aether-boost-rating {
				top: 9px;
				left: 9px;
			}

			.aether-boost-score {
				width: 42px;
				height: 42px;
				font-size: 18px;
			}

			.aether-boost-score--range {
				font-size: 11px;
			}

			.aether-boost-authority {
				margin-top: 4px;
				font-size: 6px;
			}
		}
			/* Aether — Sale / Sold Out badges top-right */
.grid-view-item .sale-badge,
.grid-view-item .sold-out-badge {
  left: auto !important;
  right: 0px !important;
  top: 0px !important;
  transform: none !important;
}
	`;

	document.head.appendChild(style);
})();
